import { formatDistance } from 'date-fns';
import { useAppUser } from 'global/cnr/contexts/useHelpers/useAppUser';
import { showAppManagerTypes, userMenuItems_all, userMenuItems_edit, userMenuItems_external, userMenuItems_send } from 'global/cnr/reducers/AppUserManagerReducer';
import { sendPushToAdmin } from 'global/cnr/reducers/reducerHelpers/adminHelpers';
import { signInResponseTypes } from 'global/cnr/reducers/SignInReducer';
import ConfirmationQuestion from 'global/components/alerts/ConfirmationQuestion';
import UserAuth from 'global/components/user/UserAuth';
import UserProfile from 'global/components/user/UserProfile';
import TreeViewer from 'global/components/viewers/TreeViewer';
import { appFormTypes } from 'global/enums/appFormTypes';
import DirectMessage from 'global/messages/DirectMessage';
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares ';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Card, Dropdown, Icon, Image, Label } from 'semantic-ui-react';
import { AppUserManagementContext } from '../cnr/contexts/AppUserManagementContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { uniqueKey } from '../common/keys';
import { appIconTypes } from '../enums/appIconTypes';
import { gEnums } from '../enums/globalEnums';
import { listHelpers } from '../lists/lists';
import SquaresFcm from '../messages/SquaresFcm';
import { _dragModes } from 'global/dragNDrops/DraggableItem';

const AppUserCard = (props) => {

  const { onDrop, appUser, appUserUrl, appUserSrc, origin, index, handleGoToEvent, handleSignInAs, viewOnly, uniqueProps, fromSidebar, showTreeViewer } = props
  const { displayName, firstName, lastName, email, _itemKey, events, clients, aboutMe, bio, metadata } = appUser
  const { lastSignInTime, creationTime, lastRefreshTime, found, recent } = metadata ?? {}
  const name = displayName ? displayName : lastName + ', ' + firstName

  const _found = found || lastRefreshTime ? true : false

  const { showAppManagerType, appUserFns } = useAppUser({ selectedAppUser: appUser, selectedAppUserKey: _itemKey })

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fn_cls } = parentContext ?? {}
  const { currentSettings_state, eventInfo_state } = states
  const { staticViews } = eventInfo_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { projectOptions } = aps_global ?? {}
  const { showAppUserTimeDifferences } = projectOptions ?? {}
  const { adminNotifications } = aps_global ?? {}

  // appUserManagementContext
  const appUserManagementContext = useContext(AppUserManagementContext)
  const { appUserManagement_state, appUserManagement_handlers } = appUserManagementContext ?? {}
  const { allowAppUserModification } = appUserManagement_state ?? {}

  const [showEventsKey, setShowEventsKey] = useState()
  const [showFcms, setShowFcms] = useState()
  const [modLevel, setModLevel] = useState()

  useEffect(() => {
    setShowFcms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUser]);

  const hc = (mt) => {
    switch (mt?.key) {
      case userMenuItems_all.editAuthorization:
      case userMenuItems_all.editEmail:
      case userMenuItems_all.editProfile:
      case userMenuItems_all.sendEmail:
      case userMenuItems_all.sendPasswordResetEmail:
      case userMenuItems_all.sendPushNotification:
      case userMenuItems_all.sendSms:
        appUserFns.handleShow_appManagerType(mt.key)
        break;
      case userMenuItems_all.openAuth:
        appUserFns.handleOpen_auth()
        break;
      case userMenuItems_all.openProfile:
        appUserFns.handleOpen_profile()
        break;
      case userMenuItems_all.resetDisclaimerResponses:
        appUserFns.handleReset_disclaimerResponses()
        break;
    }
  }

  const handleClick = () => {
    appUserManagement_handlers.handleSelect_appUser(appUser, _itemKey)
  }

  const handleShowEvents = (e) => {
    e.stopPropagation()
    setShowEventsKey(!showEventsKey)
  }

  const handleShowFcms = (e) => {
    e.stopPropagation()
    setShowFcms(!showFcms)
  }

  const handleModChange = (e, a) => {
    setModLevel()
  }

  const event_labels = (events) => {
    const lbls = []
    _.forEach(events, (event, key) => {
      const { name } = event ?? {}
      lbls.push(<Label key={uniqueKey('aulel', 'c', key, _itemKey)} onClick={(e) => { !viewOnly && handleGoToEvent && handleGoToEvent(e) }}>
        <Icon name='calendar check outline' color={'green'} />{name ? name : key}
      </Label>)
    })
    return lbls
  }

  const eventLabels = (_itemKey, events) => {
    if (events) {
      return <>
        <Label
          color={showEventsKey ? 'blue' : 'black'}
          size='small'
          style={{ float: 'right' }}
          onClick={(e) => { !viewOnly && handleShowEvents(e) }}>
          {'Events: ' + _.size(events)}
          <Icon name={showEventsKey ? 'angle down' : 'angle right'} style={{ float: 'right' }} />
        </Label>
        {showEventsKey && event_labels(events)}
      </>
    }
  }

  const icon = (name, color, oc, itemData, _itemKey, title) => <Icon key={uniqueKey('aul', 'i', name)} name={name} color={color} title={title} onClick={(e) => { !viewOnly && oc && oc(e, itemData, _itemKey) }} />

  const iconn = (caption, name, color, oc, itemData, _itemKey, title) => <Label size='mini' key={uniqueKey('aul', 'i', name)} color={color} title={title} onClick={(e) => { oc && oc(e, itemData, _itemKey) }}>
    <Icon name={name} />
    {caption}
  </Label>

  const signInIcon = (itemData, _itemKey) => {
    return <div style={{ float: 'right' }}>
      {icon('sign in', 'green', handleSignInAs, itemData, _itemKey, 'Sign In As')}
    </div>
  }

  const cardIcons = (itemData, _itemKey) => {
    const { email, fcmTokens, phoneNumber } = itemData ?? {}
    const _hasTokens = fcmTokens && Object.keys(fcmTokens).length > 0
    return [
      icon(appIconTypes.mail, email ? 'blue' : 'grey', null, null, null, 'Email'),
      iconn(fcmTokens ? Object.keys(fcmTokens).length : 0, appIconTypes.pushNotifications, fcmTokens ? 'orange' : 'grey', _hasTokens ? handleShowFcms : null, null, null, 'Push Tokens'),
      icon(appIconTypes.phone, phoneNumber ? 'blue' : 'grey', null, null, null, 'Phone')
    ]
  }

  const clientLabels = (_itemKey, clients) => {
    const lbls = []
    if (clients) {
      Object.keys(clients).forEach(clientKey => {
        const client = clients[clientKey]
        const { events } = client ?? {}
        if (events) {
          Object.keys(events).forEach(eventKey => {
            const event = events[eventKey]
            const { name } = event ?? {}
            lbls.push(<Label key={uniqueKey('aulcl', 'c', _itemKey, eventKey)}>{clientKey}</Label>)
            lbls.push(<Label key={uniqueKey('aulcl', 'e', _itemKey, eventKey)}>{name ? name : eventKey}</Label>)
          })
        }
      })
    }
    return lbls
  }

  const modsContent = () => <Dropdown
    placeholder={_.startCase('Modification')}
    label={'TEST'}
    fluid
    selection
    options={listHelpers.listListO(gEnums.accessLevels)}
    value={modLevel}
    onChange={handleModChange} />

  const metaContent = () => {
    if (_found || recent) {
      const _lastSignInTime = lastSignInTime ? formatDistance(new Date(lastSignInTime), new Date(), { addSuffix: true }) : '?'
      const _creationTime = creationTime ? formatDistance(new Date(creationTime), new Date(), { addSuffix: true }) : '?'
      const _lastRefreshTime = lastRefreshTime ? formatDistance(new Date(lastRefreshTime), new Date(), { addSuffix: true }) : '?'
      return <Card.Content className='app-user-meta'>
        <Card.Meta><Icon color='green' name='clock outline' />{showAppUserTimeDifferences ? _lastRefreshTime : lastRefreshTime}</Card.Meta>
        <Card.Meta><Icon color='blue' name='sign-in' />{showAppUserTimeDifferences ? _lastSignInTime : lastSignInTime}</Card.Meta>
        <Card.Meta><Icon color='yellow' name='user' />{showAppUserTimeDifferences ? _creationTime : creationTime}</Card.Meta>
      </Card.Content>
    } else {
      return <Card.Content className='app-user-meta'>
        <Card.Meta><Icon color='red' name='ban' />{'Not Found'}</Card.Meta>
      </Card.Content>
    }
  }

  const uniqMetas = () => {
    if (uniqueProps) {
      const metas = []
      _.forEach(uniqueProps, (uniqueProp) => {
        if (staticViews && staticViews[uniqueProp] && appUser[uniqueProp] && _.isArray(appUser[uniqueProp])) {
          const sv = staticViews[uniqueProp]
          const _array = appUser[uniqueProp]
          _.forEach(_array, (a) => {
            const name = sv[a].name
            metas.push(<Card.Meta>{name}</Card.Meta>)
          })
        }
      })
      return metas
    }
  }

  const appUserProfile = () => {
    return <div>APP USER PROFILE</div>
  }

  const appUserUpdateProfile = () => {
    return <div>appUserUpdateProfile</div>
  }

  const ims_normal = () => {
    const mis = _.mapValues(_.keyBy(userMenuItems_edit), (v) => ({
      caption: _.startCase(v),
      icon: v.startsWith('open') ? appIconTypes.externalAlternate : appIconTypes.arrowRight,
      iconColor: v.startsWith('open') ? 'orange' : null,
    }));
    return <ItemMenuSquares caption={'Options'} menuItems={mis} onClick={hc} icon={'options'} />
  }

  const ims_send = () => {
    const mis = _.mapValues(_.keyBy(userMenuItems_send), (v) => ({
      caption: _.startCase(v),
      icon: v.startsWith('open') ? appIconTypes.externalAlternate : appIconTypes.arrowRight,
      iconColor: v.startsWith('open') ? 'orange' : null,
    }));
    return <ItemMenuSquares caption={'Send'} menuItems={mis} onClick={hc} icon={'send'} />
  }

  const ims_external = () => {
    const mis = _.mapValues(_.keyBy(userMenuItems_external), (v) => ({
      caption: _.startCase(v),
      icon: v.startsWith('open') ? appIconTypes.externalAlternate : appIconTypes.arrowRight,
      iconColor: v.startsWith('open') ? 'orange' : null,
    }));
    return <ItemMenuSquares caption={'External'} menuItems={mis} onClick={hc} icon={'external alternate'} iconColor={'orange'} />
  }

  const confirmation_sendPasswordReset = () => <ConfirmationQuestion
    header={'Please Confirm'}
    question={'Send password reset email ' + email + '?'}
    buttonCaption={'Send'}
    buttonIcon={'send'}
    handleNo={appUserFns.handleShow_appManagerType}
  // handleYes={sendPasswordReset}
  />

  const altContent = () => {
    switch (showAppManagerType) {
      // case showAppManagerTypes.emailSignInLink:
      //   return confirmation_sendSignInLink()
      case showAppManagerTypes.emailPasswordReset:
      case userMenuItems_all.sendPasswordResetEmail:
        return confirmation_sendPasswordReset()
      case showAppManagerTypes.email:
      case userMenuItems_all.sendEmail:
        return <DirectMessage appFormType={appFormTypes.emailDirect} handleCancel={appUserFns.handleShow_appManagerType} />
      case showAppManagerTypes.notification:
      case userMenuItems_all.sendPushNotification:
        return <DirectMessage appFormType={appFormTypes.notificationsDirect} handleCancel={appUserFns.handleShow_appManagerType} />
      case showAppManagerTypes.sms:
      case userMenuItems_all.sendSms:
        return <DirectMessage appFormType={appFormTypes.smsDirect} handleCancel={appUserFns.handleShow_appManagerType} />
      case showAppManagerTypes.auth:
      case userMenuItems_all.editAuthorization:
        return <UserAuth inApp={true} handleCancel={appUserFns.handleShow_appManagerType} />
      case showAppManagerTypes.profile:
      case userMenuItems_all.editProfile:
        return <UserProfile handleCancel={appUserFns.handleShow_appManagerType} />
      case userMenuItems_all.sendSms:
      case userMenuItems_all.sendSms:
      default:
        return <div>{showAppManagerType}</div>
    }
  }

  const urlImage = () => {
    if (appUserSrc) {
      return <Image src={appUserSrc} size='small' style={{ padding: '.25em', marginRight: '1em' }} />
    } else if (appUserUrl) {
      return <Image src={appUserUrl} size='small' style={{ padding: '.25em', marginRight: '1em' }} />
    } else {
      return <Icon name='user' size='large' color='grey' style={{ marginRight: '.75em' }} />
    }
  }

  const appUserCard = useMemo(() => {

    return <Card as='div'
      fluid
      key={uniqueKey('aul', index)}
      className={'card-normal'}
    // onDragOver={(e) => e.preventDefault()}
    // onDrop={(e) => {
    //   onDrop && onDrop(e, JSON.stringify(appUser));
    // }}
    >
      <Card.Content onClick={() => { !viewOnly && handleClick && handleClick(appUser, _itemKey) }}>
        <Card.Header as={'h5'}>{urlImage()}{name}{!viewOnly && signInIcon(appUser, _itemKey)}</Card.Header>
        <Card.Meta>{lastName}{', '}{firstName}</Card.Meta>
        <Card.Meta>{email}</Card.Meta>
        {uniqMetas()}
      </Card.Content>
      {showTreeViewer && <Card.Content extra className={'aul-events crdi ipr-3'}>
        {ims_normal()}
      </Card.Content>}
      {showTreeViewer && <Card.Content extra className={'aul-events crdi ipr-3'}>
        {ims_send()}
      </Card.Content>}
      {showTreeViewer && <Card.Content extra className={'aul-events crdi ipr-2'}>
        {ims_external()}
      </Card.Content>}
      <Card.Content extra className={'aul-events crdi'}>
        {cardIcons(appUser, _itemKey)}
      </Card.Content>
      {showFcms && <Card.Content extra className={'aul-events'}>
        <SquaresFcm selectedAppUser={appUser} />
      </Card.Content>}
      {!viewOnly && events && <Card.Content extra className={'aul-events'}>
        {eventLabels(_itemKey, events)}
      </Card.Content>}
      {!viewOnly && events && aboutMe && <Card.Content extra >
        {aboutMe}
      </Card.Content>}
      {!viewOnly && events && bio && <Card.Content extra >
        {bio}
      </Card.Content>}
      {!viewOnly && clients && <Card.Content extra className={'aul-events'}>
        {clientLabels(_itemKey, clients)}
      </Card.Content>}
      {allowAppUserModification && <Card.Content extra className={'aul-mods'}>
        {modsContent(_itemKey, clients)}
      </Card.Content>}
      {metadata && metaContent()}
      {fromSidebar && <Card.Content className={'aul-mods'}>
        {appUserProfile()}
      </Card.Content>}
      {showTreeViewer && <TreeViewer data={appUser} scNames={true} />}
      {origin === 'aud' && appUser._hasProfile === false && (
        <Card.Content className='aul-mods'>
          {appUserUpdateProfile()}
        </Card.Content>
      )}
    </Card>

  }, [appUser, showEventsKey, showFcms]);

  return showAppManagerType ? altContent() : appUserCard
}

export default AppUserCard